(function(){
  "use strict";
  var $=function(s,r){return (r||document).querySelector(s)};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};

  // ---- header scroll + sticky mobile bar (NOTE: on desktop the scroll happens inside .page-wrapper, not window) ----
  var header=$("#header");
  var pw=document.querySelector(".page-wrapper");
  var getY=function(){ var y=window.scrollY||window.pageYOffset||0; if(pw&&pw.scrollTop>y)y=pw.scrollTop; return y; };
  var onScroll=function(){
    var y=getY();
    if(header){ if(y>40)header.classList.add("scrolled");else header.classList.remove("scrolled"); }
    var mbar=$("#mbar");
    if(mbar){ var show=y>(window.innerHeight*0.6); if(window.innerWidth<=760&&show)mbar.classList.add("show");else mbar.classList.remove("show"); }
  };
  window.addEventListener("scroll",onScroll,{passive:true});
  if(pw)pw.addEventListener("scroll",onScroll,{passive:true});
  window.addEventListener("resize",onScroll);onScroll();

  // ---- fixed-header height -> CSS var (for content offset below the sticky header) ----
  var cqHead=$("#cqHead");
  var setHeadH=function(){ if(cqHead){ var h=cqHead.offsetHeight; if(h>10) document.documentElement.style.setProperty("--cq-head-h", h + "px"); } };
  setHeadH(); window.addEventListener("resize",setHeadH); window.addEventListener("load",setHeadH);
  document.addEventListener("DOMContentLoaded",setHeadH);
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(setHeadH);

  // ---- reveal on scroll ----
  if("IntersectionObserver" in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target)}})},{threshold:0.12,rootMargin:"0px 0px -40px 0px"});
    $$(".reveal").forEach(function(el){io.observe(el)});
  }else{$$(".reveal").forEach(function(el){el.classList.add("in")})}

  // ---- mobile menu ----
  var mmenu=$("#mmenu");
  var openMenu=function(){if(mmenu)mmenu.classList.add("open");document.body.style.overflow="hidden"};
  var closeMenu=function(){if(mmenu)mmenu.classList.remove("open");document.body.style.overflow=""};
  var hb=$("#hamburger"); if(hb)hb.addEventListener("click",openMenu);
  var mcl=$("#mmenuClose"); if(mcl)mcl.addEventListener("click",closeMenu);
  $$("#mmenu [data-close]").forEach(function(a){a.addEventListener("click",closeMenu)});

  // ---- smooth-scroll for in-page anchor links (#ws-apply, #ws-range, etc.) — scrolls the correct container (.page-wrapper at >=990px, else window) with the fixed-header offset ----
  document.addEventListener("click",function(e){
    var a=e.target.closest?e.target.closest('a[href^="#"]'):null;
    if(!a)return;
    var href=a.getAttribute("href");
    if(!href||href.length<2)return;
    var target;try{target=document.querySelector(href)}catch(err){return}
    if(!target)return;
    e.preventDefault();
    var headH=parseInt(getComputedStyle(document.documentElement).getPropertyValue("--cq-head-h"))||100;
    if(window.innerWidth>=990&&pw){
      pw.scrollTo({top:target.getBoundingClientRect().top-pw.getBoundingClientRect().top+pw.scrollTop-headH-14,behavior:"smooth"});
    }else{
      window.scrollTo({top:target.getBoundingClientRect().top+(window.pageYOffset||0)-headH-14,behavior:"smooth"});
    }
  });

  // ---- cart drawer open/close ----
  var cartEl=$("#cart"),overlay=$("#overlay");
  var openCart=function(){if(cartEl)cartEl.classList.add("open");if(overlay)overlay.classList.add("show");document.body.style.overflow="hidden"};
  var closeCart=function(){if(cartEl)cartEl.classList.remove("open");if(overlay)overlay.classList.remove("show");document.body.style.overflow=""};
  var cClose=$("#cartClose"); if(cClose)cClose.addEventListener("click",closeCart);
  var cKeep=$("#cartKeep"); if(cKeep)cKeep.addEventListener("click",closeCart);
  if(overlay)overlay.addEventListener("click",function(){closeCart();closeMenu()});

  // ---- toast ----
  var toast=$("#toast"),toastMsg=$("#toastMsg"),toastT;
  var showToast=function(msg){if(!toast)return;if(toastMsg)toastMsg.textContent=msg;toast.classList.add("show");clearTimeout(toastT);toastT=setTimeout(function(){toast.classList.remove("show")},2200)};

  // ============================================================
  //  REAL SHOPIFY AJAX CART
  // ============================================================
  var money=function(c){var v=c/100;return "$"+v.toLocaleString("en-US",{minimumFractionDigits:(c%100?2:0),maximumFractionDigits:2})};

  var cartRender=function(){
    return fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json()}).then(function(cart){
      var items=$("#cartItems"),empty=$("#cartEmpty");
      $$(".citem").forEach(function(n){n.remove()});
      if(empty)empty.style.display=cart.item_count? "none":"block";
      (cart.items||[]).forEach(function(it){
        var row=document.createElement("div");row.className="citem";
        var sub=(it.variant_title && it.variant_title!=="Default Title")? it.variant_title : (it.product_type||"");
        row.innerHTML=
          '<div class="citem__img" style="background-image:url(\''+(it.image||"")+'\');background-size:cover;background-position:center"></div>'+
          '<div><div class="citem__name">'+it.product_title+'</div><div class="citem__scent">'+sub+'</div>'+
          '<div class="citem__qty"><button data-act="dec" data-key="'+it.key+'" data-q="'+it.quantity+'" aria-label="Decrease">−</button><span>'+it.quantity+'</span><button data-act="inc" data-key="'+it.key+'" data-q="'+it.quantity+'" aria-label="Increase">+</button></div></div>'+
          '<div style="text-align:right"><div class="citem__price">'+money(it.final_line_price)+'</div><button class="citem__rm" data-act="rm" data-key="'+it.key+'">Remove</button></div>';
        if(items)items.appendChild(row);
      });
      var s=$("#cartSubtotal"); if(s)s.textContent=money(cart.total_price);
      var cnt=$("#cartCount"); if(cnt){cnt.textContent=cart.item_count; cart.item_count>0?cnt.classList.add("show"):cnt.classList.remove("show");}
      var hc=$("#cartHeadCount"); if(hc)hc.textContent="("+cart.item_count+")";
      return cart;
    }).catch(function(){});
  };

  var cartAdd=function(id,qty){
    return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:id,quantity:qty||1})})
      .then(function(r){ if(!r.ok){ return r.json().then(function(e){throw e}); } return r.json(); })
      .then(function(){ return cartRender(); })
      .then(function(){ openCart(); showToast("Added to your bag"); })
      .catch(function(){ showToast("Sorry — this item couldn't be added"); });
  };

  var cartChange=function(key,qty){
    return fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json()}).then(function(){return cartRender()});
  };

  // open cart (header icon) — refresh first
  var cOpen=$("#cartOpen"); if(cOpen)cOpen.addEventListener("click",function(e){e.preventDefault();cartRender();openCart()});

  // intercept ALL native add-to-cart forms site-wide (homepage sections + Horizon product pages) → open OUR cart drawer.
  // capture phase + stopPropagation so the theme's own product-form handler doesn't also run (no double-add / no redirect).
  document.addEventListener("submit",function(e){
    var form=e.target.closest? e.target.closest('form[action="/cart/add"]'):null;
    if(!form)return;
    var idEl=form.querySelector('[name="id"]'); if(!idEl||!idEl.value)return;
    e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation)e.stopImmediatePropagation();
    var qtyEl=form.querySelector('[name="quantity"]'); var qty=qtyEl&&qtyEl.value?parseInt(qtyEl.value,10):1; if(!qty||qty<1)qty=1;
    var btn=form.querySelector('[type="submit"]')||form.querySelector('button'); var orig=btn?btn.textContent:"";
    if(btn){btn.disabled=true;btn.textContent="Adding…";}
    cartAdd(idEl.value,qty).then(function(){ if(btn){btn.disabled=false;btn.textContent=orig;} });
  },true);

  // qty / remove inside drawer
  var ci=$("#cartItems");
  if(ci)ci.addEventListener("click",function(e){
    var b=e.target.closest("button[data-act]");if(!b)return;
    var key=b.getAttribute("data-key");if(!key)return;
    var act=b.getAttribute("data-act"),q=parseInt(b.getAttribute("data-q")||"1",10);
    if(act==="inc")cartChange(key,q+1);
    else if(act==="dec")cartChange(key,Math.max(0,q-1));
    else if(act==="rm")cartChange(key,0);
  });

  // checkout
  var checkoutBtn=$("#cartCheckout"); if(checkoutBtn)checkoutBtn.addEventListener("click",function(){window.location.href="/checkout"});

  // sticky mobile bar -> add the first product form (the Signature / Feature product)
  var mbarBtn=$("#mbar button");
  if(mbarBtn)mbarBtn.addEventListener("click",function(e){
    e.preventDefault();
    var f=document.querySelector('form[action="/cart/add"]');
    if(f){ if(f.requestSubmit)f.requestSubmit(); else f.dispatchEvent(new Event("submit",{cancelable:true,bubbles:true})); }
    else showToast("Add to cart is unavailable");
  });

  // ---- wholesale form (front-end confirmation) ----
  var wsForm=$("#wsForm");
  if(wsForm)wsForm.addEventListener("submit",function(e){
    e.preventDefault();
    var req=wsForm.querySelectorAll("[required]");var ok=true;
    req.forEach(function(f){if(!f.value){ok=false;f.style.borderColor="#7a2730"}else{f.style.borderColor=""}});
    if(!ok){showToast("Please complete the required fields");return}
    wsForm.style.display="none";var s=$("#wsSuccess");if(s){s.classList.add("show");s.scrollIntoView({behavior:"smooth",block:"center"})}
  });

  // ---- newsletter ----
  var nf=$("#newsForm");
  if(nf)nf.addEventListener("submit",function(e){e.preventDefault();var inp=this.querySelector("input");if(inp&&inp.value){var ok=$("#newsOk");if(ok)ok.classList.add("show");inp.value="";showToast("Welcome to the House of Memory")}});

  // ---- initial cart state ----
  cartRender();
})();

/* ===== MOBILE CAROUSEL DOTS — pagination under every mobile card-carousel (steps, testimonials, why-choose, gifting, our-story, etc.) ===== */
(function(){
  var SEL = ".wb-grid,.gpg-why,.gpg-grid,.os-values,.steps,.mem__grid";
  function cardsOf(g){ return Array.prototype.filter.call(g.children, function(c){ return c.nodeType===1; }); }
  function isCar(g){ return getComputedStyle(g).overflowX !== "visible" && g.scrollWidth > g.clientWidth + 4; }
  function build(g){
    if(g.__dots) return;
    var cards = cardsOf(g);
    if(cards.length < 2) return;
    var nav = document.createElement("div");
    nav.className = "clq-dots";
    cards.forEach(function(card,i){
      var d = document.createElement("button");
      d.type = "button";
      d.className = "clq-dot" + (i===0 ? " is-active" : "");
      d.setAttribute("aria-label","Go to item "+(i+1));
      d.addEventListener("click",function(){ card.scrollIntoView({behavior:"smooth",inline:"center",block:"nearest"}); });
      nav.appendChild(d);
    });
    g.parentNode.insertBefore(nav, g.nextSibling);
    g.__dots = nav;
    g.__io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting){
          var idx = cards.indexOf(e.target);
          if(idx > -1) nav.querySelectorAll(".clq-dot").forEach(function(dd,di){ dd.classList.toggle("is-active", di===idx); });
        }
      });
    }, {root:g, threshold:0.55});
    cards.forEach(function(c){ g.__io.observe(c); });
  }
  function kill(g){ if(g.__io){ g.__io.disconnect(); g.__io=null; } if(g.__dots){ g.__dots.remove(); g.__dots=null; } }
  function refresh(){ document.querySelectorAll(SEL).forEach(function(g){ if(isCar(g)) build(g); else kill(g); }); }
  if(document.readyState !== "loading") refresh(); else document.addEventListener("DOMContentLoaded", refresh);
  window.addEventListener("load", refresh);
  var rt; window.addEventListener("resize", function(){ clearTimeout(rt); rt = setTimeout(refresh, 250); });
})();
